import axios from "axios";
import { API_URL, API_BASE_PATH } from "./api";

/** Axios instance without auth headers — for public endpoints (e.g. marketing enquiry). */
const publicApi = axios.create({
  baseURL: `${API_URL}${API_BASE_PATH}`,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default publicApi;
